export default "__VITE_PUBLIC_ASSET__3fe7deea__"